import { nafColor } from '@nafcore/theme';
import { colors } from '@naf-simba/theme';

export const ChatStyles = `
  [class*="-user"] {
    [class*="messageContent-"] {
      background-color: ${nafColor.secondary.glacier}!important;
    }
  }
  [data-puzzel-chat] {
    z-index: 85;
    h1 {
      font-family: questa-sans;
    }
    .circle-0-0-30 {
      background-color: ${colors.secondary[500]};
    }
    form button {
      border-radius: 8px;
    }
    input {
      font-variant: lining-nums;
    }
  }
  [class*="message-"] {
    font-size: 0.75rem!important;
  }
  [class*="-meta-text"] {
    font-size: 0.75rem!important;
    margin-top: -1rem!important;
  }
  [class*="-meta-time"] {
    font-size: 0.75rem!important;
    span {
      font-size: 0.75rem!important;
      vertical-align: sub;
    }
  }
  .mobile {
    input[type='text'],
    input[type='number'],
    input[type='email'],
    textarea {
      font-size: 1rem;
    }
  }
`;
